import { useMe } from "@/hooks/use-me";
import { useWorkspaceStore } from "@/store/workspace-store";

// /me's company is the user's "company manager" affiliation and can point at a
// different org than the workspace they're actually in — see the historical
// quota mismatch where workspaces_used returned 0 because the FE asked the
// wrong org. The active workspace's affiliated_company is the authoritative
// org for everything scoped to that workspace (billing, quota, add-ons).
export function useActiveOrg() {
  const { company } = useMe();
  const { activeWorkspace } = useWorkspaceStore();

  const orgId =
    activeWorkspace?.affiliated_company?._id ?? company?.id;
  const orgName =
    activeWorkspace?.affiliated_company?.company_name ??
    company?.companyName;
  // The org-settings layout 403-bounces non-admin members on every billing
  // endpoint, so call sites should only surface a clickable link for admins.
  const isOrgAdmin = activeWorkspace?.role === "company manager";
  const billingHref = isOrgAdmin && orgId
    ? `/org/${orgId}/settings/billing`
    : null;

  return { orgId, orgName, isOrgAdmin, billingHref };
}
